import React from 'react';
import { Outlet } from 'react-router-dom';

const Events = () => {
    return (
        <>
            <Outlet />
        </>
    );
};

export default Events;